import React from "react";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ProductVerification from "./components/ProductVerification";

function Home() {
  return (
    <>
      <Helmet>
        <title>Bar Juice Product Verification</title>
        <meta
          name="description"
          content="Verify the authenticity of your Bar Juice products"
        />
        <meta name="robots" content="noindex, nofollow" />
        <meta
          httpEquiv="Content-Security-Policy"
          content="default-src 'self'; script-src 'self' 'unsafe-inline'; style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; font-src 'self' https://fonts.gstatic.com; img-src 'self' data: https:; connect-src 'self' http://localhost:*;"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <div
        style={{
          padding: "1rem",
          textAlign: "center",
          minHeight: "100vh",
          color: "white",
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          margin: 0,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "url('/images/metal.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            padding: "1.5rem",
            borderRadius: "10px",
            maxWidth: "600px",
            width: "90%",
            margin: "0 auto",
            backdropFilter: "blur(5px)",
          }}
        >
          <img
            src="/images/BJ-logo.png"
            alt="Bar Juice Logo"
            style={{
              width: "180px",
              marginBottom: "1.5rem",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              filter: "brightness(0) invert(1)",
            }}
          />
          <h1
            style={{
              marginBottom: "1rem",
              fontSize: "clamp(1.8rem, 5vw, 2.5rem)",
            }}
          >
            Bar Juice Product Verification
          </h1>
          <p
            style={{
              fontSize: "clamp(1.1rem, 3vw, 1.2rem)",
              lineHeight: "1.4",
            }}
          >
            Please scan a QR code or enter a verification code in the URL:
            /verify/[CODE]
          </p>
        </div>
      </div>
    </>
  );
}

function App() {
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/verify/:code",
        element: <ProductVerification />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
    {
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
        v7_normalizeFormMethod: true,
      },
    }
  );

  return <RouterProvider router={router} />;
}

export default App;
